import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberUsernameToMemberIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberUsernameToMemberId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PIIString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberIdFromUsername"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberUsernameToMemberId","document":MemberUsernameToMemberIdDocument}} as const;
export type MemberUsernameToMemberIdQueryVariables = Types.Exact<{
  username?: Types.InputMaybe<Types.Scalars['PIIString']['input']>;
}>;


export type MemberUsernameToMemberIdQuery = (
  { __typename: 'Query' }
  & { memberIdFromUsername?: Types.Maybe<(
    { __typename: 'MemberWithId' }
    & Pick<Types.MemberWithId, 'id'>
  )> }
);

/**
 * __useMemberUsernameToMemberIdQuery__
 *
 * To run a query within a React component, call `useMemberUsernameToMemberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberUsernameToMemberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberUsernameToMemberIdQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useMemberUsernameToMemberIdQuery(
  baseOptions?: TrelloQueryHookOptions<
    MemberUsernameToMemberIdQuery,
    MemberUsernameToMemberIdQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberUsernameToMemberIdDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MemberUsernameToMemberIdQuery,
    MemberUsernameToMemberIdQueryVariables
  >(MemberUsernameToMemberIdDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberUsernameToMemberIdLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberUsernameToMemberIdQuery,
    MemberUsernameToMemberIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberUsernameToMemberIdQuery,
    MemberUsernameToMemberIdQueryVariables
  >(MemberUsernameToMemberIdDocument, options);
}
export function useMemberUsernameToMemberIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberUsernameToMemberIdQuery,
        MemberUsernameToMemberIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberUsernameToMemberIdQuery,
    MemberUsernameToMemberIdQueryVariables
  >(MemberUsernameToMemberIdDocument, options);
}
export type MemberUsernameToMemberIdQueryHookResult = ReturnType<
  typeof useMemberUsernameToMemberIdQuery
>;
export type MemberUsernameToMemberIdLazyQueryHookResult = ReturnType<
  typeof useMemberUsernameToMemberIdLazyQuery
>;
export type MemberUsernameToMemberIdSuspenseQueryHookResult = ReturnType<
  typeof useMemberUsernameToMemberIdSuspenseQuery
>;
export type MemberUsernameToMemberIdQueryResult = Apollo.QueryResult<
  MemberUsernameToMemberIdQuery,
  MemberUsernameToMemberIdQueryVariables
>;
